var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResizeHandler(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_3361_8402)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11.1094,
    y: 11.1113,
    width: 38,
    height: 38,
    rx: 6,
    fill: "#19181D",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.4542,
    y: 10.4562,
    width: 39.3103,
    height: 39.3103,
    rx: 6.65517,
    stroke: "#808080",
    strokeWidth: 1.31034,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8064 22.4539V37.7686C30.8064 37.9532 30.7331 38.1303 30.6026 38.2608C30.472 38.3914 30.295 38.4647 30.1103 38.4647C29.9257 38.4647 29.7486 38.3914 29.6181 38.2608C29.4875 38.1303 29.4142 37.9532 29.4142 37.7686V22.4539C29.4142 22.2693 29.4875 22.0922 29.6181 21.9617C29.7486 21.8312 29.9257 21.7578 30.1103 21.7578C30.295 21.7578 30.472 21.8312 30.6026 21.9617C30.7331 22.0922 30.8064 22.2693 30.8064 22.4539ZM27.3258 29.4151H22.0449L23.6416 27.8193C23.7722 27.6887 23.8456 27.5115 23.8456 27.3268C23.8456 27.1421 23.7722 26.9649 23.6416 26.8343C23.511 26.7037 23.3338 26.6303 23.1491 26.6303C22.9644 26.6303 22.7872 26.7037 22.6566 26.8343L19.8721 29.6188C19.8074 29.6834 19.7561 29.7602 19.721 29.8447C19.686 29.9292 19.668 30.0198 19.668 30.1113C19.668 30.2027 19.686 30.2933 19.721 30.3778C19.7561 30.4623 19.8074 30.5391 19.8721 30.6038L22.6566 33.3882C22.7872 33.5189 22.9644 33.5923 23.1491 33.5923C23.3338 33.5923 23.511 33.5189 23.6416 33.3882C23.7722 33.2576 23.8456 33.0805 23.8456 32.8957C23.8456 32.711 23.7722 32.5339 23.6416 32.4032L22.0449 30.8074H27.3258C27.5105 30.8074 27.6875 30.734 27.8181 30.6035C27.9486 30.4729 28.022 30.2959 28.022 30.1113C28.022 29.9266 27.9486 29.7496 27.8181 29.619C27.6875 29.4885 27.5105 29.4151 27.3258 29.4151ZM40.3485 29.6188L37.564 26.8343C37.4334 26.7037 37.2563 26.6303 37.0715 26.6303C36.8868 26.6303 36.7096 26.7037 36.579 26.8343C36.4484 26.9649 36.375 27.1421 36.375 27.3268C36.375 27.5115 36.4484 27.6887 36.579 27.8193L38.1758 29.4151H32.8948C32.7102 29.4151 32.5331 29.4885 32.4026 29.619C32.272 29.7496 32.1987 29.9266 32.1987 30.1113C32.1987 30.2959 32.272 30.4729 32.4026 30.6035C32.5331 30.734 32.7102 30.8074 32.8948 30.8074H38.1758L36.579 32.4032C36.4484 32.5339 36.375 32.711 36.375 32.8957C36.375 33.0805 36.4484 33.2576 36.579 33.3882C36.7096 33.5189 36.8868 33.5923 37.0715 33.5923C37.2563 33.5923 37.4334 33.5189 37.564 33.3882L40.3485 30.6038C40.4132 30.5391 40.4646 30.4623 40.4996 30.3778C40.5347 30.2933 40.5527 30.2027 40.5527 30.1113C40.5527 30.0198 40.5347 29.9292 40.4996 29.8447C40.4646 29.7602 40.4132 29.6834 40.3485 29.6188Z",
    fill: "#FFD600"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_3361_8402",
    x: 0.000781059,
    y: 0.000781059,
    width: 60.2172,
    height: 60.2211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.84 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3361_8402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3361_8402",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -6.55172
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.66897
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_3361_8402"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeHandler);
export default __webpack_public_path__ + "static/media/resize-handler.c713f0d444412ff0eaaf0555e38d04fe.svg";
export { ForwardRef as ReactComponent };